import i18n from '@/utils/i18n'

const obligatoire = (v) => !!v || i18n.t('errors.required')

export default {
  methods: {
    obligatoireRule() {
      return obligatoire
    },
  },
}
